import Vue from 'vue';
import { transformDna } from '../util/transformDna';

export default {

    // *******
    // GENERAL
    
    getGame (state) {

        return state.game;
        
    },

    getGames (state) {

        if (!state.games) return [];

        return state.games.sort((a, b) => {
            if (a.isComplete > b.isComplete) return 1;
            if (a.isComplete < b.isComplete) return -1;

            const rewardPoolA = parseFloat(a.rewardPool);
            const rewardPoolB = parseFloat(b.rewardPool);

            if (rewardPoolA < rewardPoolB) return 1;
            if (rewardPoolA > rewardPoolB) return -1;

            return 0;
        });

    },

    getBlockHeads (state) {

        return state.blockHeads;

    },

    getUserBlockHeads (state) {

        return state.userBlockHeads;

    },

    // ****
    // USER

    getUsers (state) {
        return state.users.sort((a, b) => {

            if (a.winCount < b.winCount) return 1;
            if (a.winCount > b.winCount) return -1;

            if (a.earnings < b.earnings) return 1;
            if (a.earnings > b.earnings) return -1;

            return 0;

        });
    },

    getAddress (state) {
        return state.address;
    },

    // **************
    // User interface

    getModalType (state) {
        return state.modalType;
    },

    getLoading (state) {
        return state.loading;
    },

    getHasExtension (state) {
        return state.hasExtension;
    },

    getPendingTransaction (state) {
        return state.pendingTransaction;
    },

    getHasError (state) {
        return state.hasError;
    },

    getLocale (state) {
        return state.locale;
    },

    getLoadingUsers (state) {
        return state.loadingUsers;
    },

    getLoadingBlockWars (state) {
        return state.loadingBlockWars;
    },

    getLoadingBlockHeads (state) {
        return state.loadingBlockHeads;
    }

}



// WEBPACK FOOTER //
// ./src/store/getters.js